import type { ReactNode } from 'react';

import { getLocale } from '../../i18n';
import { count, interval, score } from './format';
import { mt } from './messages';

export function NcsValue(props: {
  score: number;
  n: number;
  interval: readonly [number, number];
}): ReactNode {
  const locale = getLocale();
  return (
    <span className="inline-flex flex-col">
      <span data-numeric className="text-title-md">
        {score(props.score, locale)}
      </span>
      <span className="text-caption text-muted-foreground flex gap-2">
        <span data-numeric>{mt('ncs.sample', { n: count(props.n, locale) })}</span>
        <span data-numeric>
          {mt('ncs.interval', {
            interval: interval(props.interval?.[0], props.interval?.[1], locale),
          })}
        </span>
      </span>
    </span>
  );
}
